import React from "react";
import {RouteObject} from "react-router-dom";
import ServicesLayout from "../../layout/ServicesLayout/ServicesLayout";
//import AllServicesList from "./AllServicesList/AllServicesList";
import ServiceCategoryMgt from "../../pages/LADService/CategoryMgt/ServiceCategoryMgt";
import ServiceSACMgt from "../../pages/LADService/SACMgt/ServiceSACMgt";
import RelatedServicesSettings from "../../pages/LADService/RelatedServicesSettings/RelatedServicesSettings";
import AllServices from "../../pages/LADService/AllServices/AllServices";
import ServicesTrash from "../../pages/LADService/Trash/ServicesTrash";
import ViewService from "../../pages/LADService/ViewService/ViewService";
import ServiceUnitSettings from "../../pages/LADService/UnitSettings/ServiceUnitSettings";
import AddServices from "../../pages/LADService/AddServices/AddServices";

const ServicesRoutes : RouteObject[] = [
    {
        path:'services',
        element:<ServicesLayout/>,
         children: [
            {
                // Default route for servic
                index: true,
                element: <AllServices/>
            },
            {
                path: 'all-services',
                element: <AllServices/>
            },
            {
                path: 'add-services',
                element: <AddServices/>
            },
            {
                path: 'services-category-management',
                element: <ServiceCategoryMgt />
            },
            {
                path: 'services-hsn-management',
                element: <ServiceSACMgt />
            },
            {
                path: 'services-unit-settings',
                element: <ServiceUnitSettings/>
            },
            {
                path: 'related-services-settings',
                element: <RelatedServicesSettings />
            },
            {
                path: 'services-trash',
                element: <ServicesTrash/>
            },
            {
                path: 'view-service/:id',
                element: <ViewService />
            },
            // {
            //     path: 'view-Rfq/:id',
            //     element: <SingleRfqView/>
            // },
        ]
    }
]

export default ServicesRoutes;